import { gerUrlForService } from "./firebase";

const ENV = import.meta.env.VITE_APP_ENV || 'dev';

export const getApiBaseUrl = (): string => {
  return gerUrlForService("sampleApi");
};

export const getTestTask = async () => {
  const baseUrl = getApiBaseUrl();
  try {
    const response = await fetch(`${baseUrl}/test-task`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "task": "test-task"
      })
    });
    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching hello:', error);
    throw error;
  }
};

export const getHello = async () => {
  const baseUrl = getApiBaseUrl();
  try {
    const response = await fetch(`${baseUrl}/hello`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching hello:', error);
    throw error;
  }
};

export const getUsers = async (token: string, maxResults?: number, pageToken?: string) => {
  const baseUrl = getApiBaseUrl();
  const url = new URL(`${baseUrl}/api/users`, window.location.origin);
  if (maxResults !== undefined) {
    url.searchParams.append('maxResults', maxResults.toString());
  }
  if (pageToken !== undefined) {
    url.searchParams.append('pageToken', pageToken);
  }
  try {
    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const getHelloAuth = async (token: string) => {
  const baseUrl = getApiBaseUrl();
  try {
    const response = await fetch(`${baseUrl}/api/hello-auth`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching hello-auth:', error);
    throw error;
  }
};